"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const defaultTheme = {
    root: 'bg-near-white br3 pa3 w5 mb2',
    header: 'flex items-center justify-between',
    name: 'f5',
    location: 'f6',
    body: '',
};
function LeadNotificationCard({ item, theme = defaultTheme, }) {
    return (React.createElement("div", { className: theme.root },
        React.createElement("div", { className: theme.header },
            React.createElement("div", { className: theme.name }, item.name),
            React.createElement("div", { className: theme.location }, item.location)),
        React.createElement("div", { className: theme.body },
            React.createElement("div", { className: theme.action }, item.action),
            React.createElement("div", { className: theme.time }, item.time)),
        React.createElement("a", { className: theme.cta, href: item.ctaLink }, item.ctaText)));
}
exports.default = LeadNotificationCard;
//# sourceMappingURL=index.js.map